import React from 'react';

const VideoSection = () => {
  return (
    <section id="video" className="video-section">
      <div className="container">
        <h2>Featured Video</h2>
        <div className="video-wrapper">
          <iframe
            id="youtubePlayer"
            width="1013"
            height="570"
            src="https://www.youtube.com/embed/ABpZnsW3NdQ?start=250"
            title="How to Improve you Prayer Life | Pavel Goia | A Chosen Generation"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          />
          <div className="video-fallback" style={{ display: 'none' }}>
            <div className="fallback-content">
              <svg
                width="80"
                height="80"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <circle cx="12" cy="12" r="10"></circle>
                <path d="M12 8v4M12 16h.01"></path>
              </svg>
              <h3>Video Embedding Disabled</h3>
              <p>
                This video cannot be embedded. The video owner has disabled playback on external websites.
              </p>
              <a
                href="https://www.youtube.com/watch?v=ABpZnsW3NdQ&t=250s"
                target="_blank"
                rel="noopener noreferrer"
                className="watch-youtube-btn"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                </svg>
                Watch on YouTube
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
